import { render, staticRenderFns } from "./EditarTitulo.vue?vue&type=template&id=7035ff12"
import script from "./EditarTitulo.vue?vue&type=script&lang=js"
export * from "./EditarTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports